import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";
import { getStatusCell } from "components/CRPComponents/Tables/GenericTable/utils/getStatusCell";
import { PublicViewButton } from "../publicView";

function List(props: ListProps) {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <GenericTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 10,
          search: null,
          status: null,
        }}
        useStatusString={true}
        path={`${props.path}/blog-posts`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.Blogs.items}
        formatPagination={(data) => data.Blogs.paginationInfo}
        title="NOVO POST"
        columnsTable={[
          {
            Header: "id",
            accessor: "id",
            Cell: ({ value }: any) => (
              <LinkCell href={`${props.path}/blog-posts/${value}`} value={value} />
            ),
          },
          {
            Header: "Títutlo",
            accessor: "title",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Nome",
            accessor: "name",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Autor",
            accessor: "autor",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "status",
            accessor: "status",
            Cell: ({ value }: any) => getStatusCell(value),
          },
          {
            Header: "Ver",
            accessor: "preview",
            Cell: ({ row }: any) => (
              <PublicViewButton
                category="blog"
                status={row.original.status}
                slug={row.original.slug}
                publishOn={row.original.publishOn}
              />
            ),
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
